import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { catchError, map, Observable, of, switchMap } from 'rxjs';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { LuzmoService } from 'app/modules/admin/analytics/services/luzmo.service';
import { injectLuzmoAssetsIntoNavigation } from 'app/shared/routes/navigation/luzmo-nav';

@Injectable({
    providedIn: 'root'
})
export class InitialDataResolver implements Resolve<any>
{
    /**
     * Constructor
     */
    constructor(
        private _navigationService: NavigationService,
        private _luzmoService: LuzmoService)
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Use this resolver to resolve initial routes for the application
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>
    {
        return this._navigationService.get().pipe(
            switchMap((navigation) =>
                this._luzmoService.getAssets().pipe(
                    catchError(() => of({assets: []})),
                    map((res) => {
                        const merged = injectLuzmoAssetsIntoNavigation(navigation, res?.assets ?? []);
                        this._navigationService.set(merged);
                        return [merged];
                    })
                )
            )
        );
    }
}
